export const UNIVERSAL_MULTI_SELECTION_RULE = "REGLA UNIVERSAL DE TOMA MULTI-SELECCIÓN Y MULTI-CANTIDAD:\nCuando el usuario seleccione O PIDA múltiples servicios o productos a la vez, DEBES aceptar la lista y sumar los precios. Luego agendar o procesar todos los ítems en un solo pedido o cita consolidada, mencionando el desglose y el costo total final.";

export const MODULE_DEFINITIONS = {
  feature_appointments: {
    key: 'feature_appointments',
    name: 'Agenda Inteligente & CRM Kanban',
    category: 'Agenda & Citas',
    description: 'Gestión automatizada de citas por WhatsApp, sincronización con Google Calendar y tablero CRM visual de prospectos.',
    benefits: [
      'Agendamiento 24/7 sin intervención humana directa',
      'Sincronización bidireccional en tiempo real con Google Calendar',
      'Tablero CRM Kanban con arrastre de leads (Agendados, Completados, No Asistió)',
      'Recordatorios automáticos para reducir el ausentismo'
    ]
  },
  feature_services: {
    key: 'feature_services',
    name: 'Catálogo de Servicios y Precios',
    category: 'Ventas & Catálogo',
    description: 'Administración de catálogo de servicios, duraciones, precios y descripciones para cotización instantánea por la IA.',
    benefits: [
      'Precios y tiempos de atención siempre actualizados',
      'Multi-selección inteligente de servicios en un solo turno',
      'Cálculo automático de duraciones y totales'
    ]
  },
  feature_orders: {
    key: 'feature_orders',
    name: 'Consola de Pedidos y Delivery',
    category: 'Restaurantes & Delivery',
    description: 'Toma y control de pedidos por WhatsApp, sitio web o salón presencial con monitor de estados para cocina y domiciliarios.',
    benefits: [
      'Recepción estructurada de pedidos con dirección y método de pago',
      'Monitor de cocina y despacho en tiempo real',
      'Copia con 1 clic del formato listo para enviar a domiciliarios'
    ]
  },
  feature_inventory: {
    key: 'feature_inventory',
    name: 'Inventario & Control de Stock',
    category: 'Operaciones',
    description: 'Control de existencias de productos en bodega, costos de compra, precio de venta y alertas de stock bajo.',
    benefits: [
      'Alertas tempranas de agotamiento de insumos y productos',
      'Historial de entradas y salidas de inventario',
      'Valorización de bodega y margen de ganancia'
    ]
  },
  feature_staff: {
    key: 'feature_staff',
    name: 'Equipo y Profesionales',
    category: 'Equipo',
    description: 'Configuración de miembros del equipo, horarios individuales por especialista y calendarios asignados.',
    benefits: [
      'Asignación automática de citas según el profesional disponible',
      'Horarios independientes por barbero, terapeuta o colaborador',
      'Acceso al portal privado para cada colaborador'
    ]
  },
  feature_commissions: {
    key: 'feature_commissions',
    name: 'Cálculo de Comisiones y Nómina',
    category: 'Finanzas',
    description: 'Liquidación automática de porcentajes de comisión por servicio realizado para cada especialista.',
    benefits: [
      'Reporte consolidado de comisiones por fecha y profesional',
      'Ahorro de horas en cálculo manual de nómina y pagos',
      'Transparencia total para tus colaboradores'
    ]
  },
  feature_finanzas: {
    key: 'feature_finanzas',
    name: 'Finanzas, Caja y Reportes',
    category: 'Finanzas',
    description: 'Métricas de ingresos diarios, semanales y mensuales, métodos de pago más usados y balance del negocio.',
    benefits: [
      'Dashboard financiero en tiempo real',
      'Gráficas de rendimiento e ingresos proyectados',
      'Control de cierres de caja'
    ]
  },
  feature_campaigns: {
    key: 'feature_campaigns',
    name: 'Campañas Masivas de WhatsApp',
    category: 'Marketing',
    description: 'Envíos masivos y segmentados de ofertas, reactivación de clientes inactivos y lanzamientos promocionales.',
    benefits: [
      'Reactivación de clientes que llevan más de 30 días sin volver',
      'Plantillas optimizadas con alta tasa de apertura',
      'Segmentación por historial de visitas o compras'
    ],
    premium: true
  },
  feature_loyalty: {
    key: 'feature_loyalty',
    name: 'Fidelización, Cupones & VIP',
    category: 'Marketing',
    description: 'Programa de puntos, tarjetas de sellos digitales y cupones de descuento para premiar a clientes recurrentes.',
    benefits: [
      'Aumento del valor de vida del cliente (LTV)',
      'Generación de cupones con fecha de caducidad',
      'Club VIP para los clientes con mayor consumo'
    ],
    premium: true
  },
  feature_prospecting: {
    key: 'feature_prospecting',
    name: 'Prospección por Google Maps',
    category: 'Marketing',
    description: 'Busca negocios en Google Maps, revisa cuáles tienen WhatsApp y prepara la lista para ofrecerles tu servicio.',
    benefits: [
      'Búsqueda por rubro y ciudad con los datos de contacto del negocio',
      'Verificación de WhatsApp antes de escribir a nadie',
      'Lista de "No contactar" que se respeta siempre'
    ],
    premium: true
  },
  feature_catalogo: {
    key: 'feature_catalogo',
    name: 'Catálogo con listas de precios',
    category: 'Ventas',
    description: 'Catálogo de productos con varias listas de precios que Keyla IA consulta para responder precios y existencias por WhatsApp.',
    benefits: [
      'Importación desde Excel o CSV, sin digitar uno por uno',
      'Una lista de precios por tipo de cliente (público, mayorista, distribuidor)',
      'El bot solo da precios que están en el catálogo'
    ],
    premium: true
  },
  feature_cotizaciones: {
    key: 'feature_cotizaciones',
    name: 'Cotizaciones y ventas',
    category: 'Ventas',
    description: 'Arma cotizaciones con los precios de tu catálogo, envíalas por WhatsApp, conviértelas en ventas, registra abonos y controla lo que te deben. No es facturación electrónica.',
    benefits: [
      'Precios, descuentos e impuestos calculados sin errores, con numeración consecutiva y versiones',
      'Ventas que descuentan y devuelven existencias del catálogo, sin vender dos veces la última unidad',
      'Abonos, saldo por venta y cartera por cliente y antigüedad, con exportación a CSV para el contador'
    ],
    premium: true
  },
  feature_identidad_ia: {
    key: 'feature_identidad_ia',
    name: 'Identidad y Personalidad IA',
    category: 'Inteligencia Artificial',
    description: 'Ajuste del tono de voz, instrucciones avanzadas, reglas de oro y restricciones para el bot de WhatsApp.',
    benefits: [
      'El bot responde con el estilo y jerga propia de tu marca',
      'Entrenamiento de preguntas frecuentes personalizadas',
      'Control de silenciamiento por chat con comando #pausar'
    ]
  },
  feature_bot_aprende: {
    key: 'feature_bot_aprende',
    name: 'Bot que pregunta al dueño y aprende',
    category: 'Inteligencia Artificial',
    description: 'Cuando el bot no sabe algo, te avisa por WhatsApp, tú respondes con un código y la respuesta queda guardada para la próxima vez.',
    benefits: [
      'El bot nunca inventa: pregunta antes de responder lo que no sabe',
      'Respondes desde tu WhatsApp con un código corto (P-12)',
      'Lo que respondes se guarda y el bot lo contesta solo después'
    ]
  },
  feature_reportes: {
    key: 'feature_reportes',
    name: 'Reporte semanal y análisis de competencia',
    category: 'Crecimiento',
    description: 'Cada lunes recibes por WhatsApp las cifras de tu negocio con 2 o 3 sugerencias concretas, y puedes pedir el análisis de tus competidores cercanos.',
    benefits: [
      'Resumen semanal de conversaciones, citas, pedidos, ventas y por cobrar',
      'Sugerencias de mejora basadas en tus propias cifras',
      'Competidores de tu zona: calificación, reseñas, fortalezas y debilidades'
    ],
    premium: true
  },
  feature_seguimiento: {
    key: 'feature_seguimiento',
    name: 'Seguimiento automático de clientes',
    category: 'Crecimiento',
    description: 'Mensajes de seguimiento por WhatsApp a quien no agendó, no respondió la cotización o vuelve a los 30 días, con límites anti-bloqueo.',
    benefits: [
      'Máximo 2 toques por cliente, en horario de 8 a 20',
      'Con aprobación previa tuya si lo prefieres',
      'Campañas enviadas desde el servidor, con reintentos y resultado real'
    ],
    premium: true
  },
  feature_contenido: {
    key: 'feature_contenido',
    name: 'Contenido con IA',
    category: 'Crecimiento',
    description: 'Textos para publicaciones, estados y anuncios, imágenes publicitarias a partir de tus fotos y auditoría de tu perfil de Instagram, con créditos mensuales.',
    benefits: [
      '3 textos por producto o servicio: publicación, estado y anuncio',
      'Imagen publicitaria generada con tu foto',
      'Auditoría del perfil con puntaje de 100 y créditos visibles'
    ],
    premium: true
  },
  feature_ads: {
    key: 'feature_ads',
    name: 'Anuncios en Meta (Click-to-WhatsApp)',
    category: 'Crecimiento',
    description: 'Gasto, conversaciones y costo por conversación de tus anuncios de Facebook e Instagram, con topes de presupuesto y gasto registrado solo en Gastos.',
    benefits: [
      'Gasto y conversaciones de cada día en un solo lugar',
      'Anuncios en dólares convertidos con la TRM oficial',
      'Topes diario y mensual para no gastar de más'
    ],
    premium: true
  },
  feature_menu_media: {
    key: 'feature_menu_media',
    name: 'Menú Multimedia (PDF & Fotos por Bot)',
    category: 'Inteligencia Artificial',
    description: 'Envío autónomo de catálogos en PDF, fotos de platos o instalaciones cuando el cliente lo solicite en WhatsApp.',
    benefits: [
      'Envío automático de PDF de carta o portafolio',
      'Fotos en alta resolución enviadas directamente al chat',
      'Cero esfuerzo manual de envío de documentos'
    ],
    premium: true
  }
};

// Nivel del plan por su nombre ("PRO", "Pro (Recomendado)", "Avanzado / VIP"...). Sin plan o desconocido = Emprendedor.
export const planTier = (plan) => {
  const n = String(plan || '').toLowerCase();
  if (n.includes('avanz') || n.includes('vip')) return 'avanzado';
  if (n.includes('pro')) return 'pro';
  return 'emprendedor';
};

// Módulos de crecimiento: el bot que aprende va en todos los planes; reportes y competencia desde PRO;
// seguimiento, contenido y anuncios son complementos (apagados hasta que se contraten).
const growthDefaults = (plan) => ({
  feature_bot_aprende: true,
  feature_reportes: planTier(plan) !== 'emprendedor',
  feature_seguimiento: false,
  feature_contenido: false,
  feature_ads: false
});

export const getDefaultFeatures = (tipoNegocio, plan = 'Emprendedor') => {
  const norm = (tipoNegocio || '').toLowerCase();
  const isRestaurante = norm.includes('restaurante') || norm.includes('comida') || norm.includes('cafeter');
  const isTienda = norm.includes('tienda') || norm.includes('retail') || norm.includes('comercio');

  if (isRestaurante) {
    return {
      feature_appointments: false,
      feature_services: true,
      feature_orders: true,
      feature_inventory: true,
      feature_staff: false,
      feature_commissions: false,
      feature_finanzas: true,
      feature_campaigns: true,
      feature_loyalty: true,
      feature_prospecting: false,
      feature_catalogo: false,
      feature_cotizaciones: false,
      feature_identidad_ia: true,
      feature_menu_media: true,
      ...growthDefaults(plan),
      bot_activo: true,
      whatsapp_enabled: true
    };
  }

  if (isTienda) {
    return {
      feature_appointments: false,
      feature_services: true,
      feature_orders: true,
      feature_inventory: true,
      feature_staff: false,
      feature_commissions: false,
      feature_finanzas: true,
      feature_campaigns: true,
      feature_loyalty: true,
      feature_prospecting: false,
      feature_catalogo: false,
      feature_cotizaciones: false,
      feature_identidad_ia: true,
      feature_menu_media: true,
      ...growthDefaults(plan),
      bot_activo: true,
      whatsapp_enabled: true
    };
  }

  // Servicios, Barberías, Salones, Spas, Clínicas, Profesionales, etc. (Default)
  return {
    feature_appointments: true,
    feature_services: true,
    feature_orders: false,
    feature_inventory: true,
    feature_staff: true,
    feature_commissions: true,
    feature_finanzas: true,
    feature_campaigns: true,
    feature_loyalty: true,
    feature_prospecting: false,
    feature_catalogo: false,
    feature_cotizaciones: false,
    feature_identidad_ia: true,
    feature_menu_media: false,
    ...growthDefaults(plan),
    bot_activo: true,
    whatsapp_enabled: true
  };
};

export const isModuleEnabled = (business, moduleKey) => {
  if (!business) return false;
  // If explicitly defined on the business object (boolean), respect it
  if (business[moduleKey] !== undefined) {
    return Boolean(business[moduleKey]);
  }
  // Otherwise fallback to default for their business type
  const defaults = getDefaultFeatures(business.tipo_negocio, business.plan);
  return defaults[moduleKey] !== undefined ? Boolean(defaults[moduleKey]) : true;
};

export const getStoredFeatureOverrides = () => {
  try {
    const raw = localStorage.getItem('keylacrm_feature_overrides');
    return raw ? JSON.parse(raw) : {};
  } catch (e) {
    return {};
  }
};

export const safeSetLocalStorage = (key, value) => {
  try {
    let cleanedValue = value;
    if (key === 'keylacrm_master_db' && Array.isArray(value)) {
      cleanedValue = value.map(b => {
        if (b.menu_pdf_url && typeof b.menu_pdf_url === 'string' && b.menu_pdf_url.startsWith('data:')) {
          return { ...b, menu_pdf_url: '' };
        }
        return b;
      });
    }
    localStorage.setItem(key, typeof cleanedValue === 'string' ? cleanedValue : JSON.stringify(cleanedValue));
  } catch (err) {
    console.warn(`[LocalStorage Safe Warning] Se omitió guardar ${key} en caché local.`, err.message);
  }
};

export const setStoredFeatureOverride = (businessId, field, value) => {
  try {
    if (typeof value === 'string' && value.startsWith('data:') && value.length > 300000) {
      return;
    }
    const overrides = getStoredFeatureOverrides();
    const strId = String(businessId);
    if (!overrides[strId]) overrides[strId] = {};
    overrides[strId][field] = value;
    safeSetLocalStorage('keylacrm_feature_overrides', overrides);
  } catch (e) {
    console.warn("Error en setStoredFeatureOverride:", e);
  }
};

export const parseFeaturesFromBusiness = (b) => {
  if (!b) return {};
  let parsed = {};
  if (b.estilo && typeof b.estilo === 'string' && b.estilo.includes('__FEATURES__:')) {
    try {
      const parts = b.estilo.split('__FEATURES__:');
      parsed = JSON.parse(parts[1].trim());
    } catch (e) {
      console.warn("Error parsing features from estilo", e);
    }
  }

  const defaults = getDefaultFeatures(b.tipo_negocio, b.plan);

  return {
    ...defaults,
    ...parsed,
    ...(b.feature_menu_media !== undefined ? { feature_menu_media: b.feature_menu_media } : {}),
    ...(b.feature_staff !== undefined ? { feature_staff: b.feature_staff } : {}),
    ...(b.feature_services !== undefined ? { feature_services: b.feature_services } : {}),
    ...(b.feature_appointments !== undefined ? { feature_appointments: b.feature_appointments } : {}),
    ...(b.feature_orders !== undefined ? { feature_orders: b.feature_orders } : {}),
    ...(b.feature_inventory !== undefined ? { feature_inventory: b.feature_inventory } : {}),
    ...(b.feature_commissions !== undefined ? { feature_commissions: b.feature_commissions } : {}),
    ...(b.feature_campaigns !== undefined ? { feature_campaigns: b.feature_campaigns } : {}),
    ...(b.feature_loyalty !== undefined ? { feature_loyalty: b.feature_loyalty } : {}),
    ...(b.feature_prospecting !== undefined ? { feature_prospecting: b.feature_prospecting } : {}),
    ...(b.feature_catalogo !== undefined ? { feature_catalogo: b.feature_catalogo } : {}),
    ...(b.feature_cotizaciones !== undefined ? { feature_cotizaciones: b.feature_cotizaciones } : {}),
    ...(b.feature_identidad_ia !== undefined ? { feature_identidad_ia: b.feature_identidad_ia } : {}),
    ...(b.feature_finanzas !== undefined ? { feature_finanzas: b.feature_finanzas } : {}),
    ...(b.feature_bot_aprende !== undefined ? { feature_bot_aprende: b.feature_bot_aprende } : {}),
    ...(b.feature_reportes !== undefined ? { feature_reportes: b.feature_reportes } : {}),
    ...(b.feature_seguimiento !== undefined ? { feature_seguimiento: b.feature_seguimiento } : {}),
    ...(b.feature_contenido !== undefined ? { feature_contenido: b.feature_contenido } : {}),
    ...(b.feature_ads !== undefined ? { feature_ads: b.feature_ads } : {}),
    ...(b.bot_activo !== undefined ? { bot_activo: b.bot_activo } : {}),
    ...(b.whatsapp_enabled !== undefined ? { whatsapp_enabled: b.whatsapp_enabled } : {}),
    menu_pdf_url: parsed.menu_pdf_url !== undefined ? parsed.menu_pdf_url : (b.menu_pdf_url || ""),
    menu_link_url: parsed.menu_link_url !== undefined ? parsed.menu_link_url : "",
    menu_text_list: parsed.menu_text_list !== undefined ? parsed.menu_text_list : "",
    muted_phones: Array.isArray(parsed.muted_phones) ? parsed.muted_phones : [],
    muted_phones_metadata: parsed.muted_phones_metadata || {}
  };
};

export const getCleanEstilo = (estiloText) => {
  if (!estiloText || typeof estiloText !== 'string') return '';
  return estiloText.split('__FEATURES__:')[0].split('[REGLAS ADICIONALES DEL NEGOCIO]')[0].trim();
};

export const getDirectMediaUrl = (url) => {
  if (!url || typeof url !== 'string') return '';
  const trimmed = url.trim();
  if (trimmed.startsWith('data:')) return trimmed;
  const match = trimmed.match(/\/d\/([a-zA-Z0-9_-]+)/);
  if (match && match[1]) {
    return `https://lh3.googleusercontent.com/d/${match[1]}`;
  }
  return trimmed;
};

export const generateTextListFromServices = (services) => {
  if (!services || !Array.isArray(services) || services.length === 0) return "";
  return services.map(s => {
    let icon = "🏷️";
    const nameLower = (s.nombre || '').toLowerCase();
    if (nameLower.includes('coca') || nameLower.includes('bebida') || nameLower.includes('jugo') || nameLower.includes('agua')) icon = "🥤";
    else if (nameLower.includes('perro') || nameLower.includes('hot dog')) icon = "🌭";
    else if (nameLower.includes('papa') || nameLower.includes('fries')) icon = "🍟";
    else if (nameLower.includes('pizza')) icon = "🍕";
    return `${icon} ${s.nombre} - $${Number(s.precio || 0).toLocaleString('es-CO')}`;
  }).join('\n');
};

export const getAllBusinessFeatures = (biz, overrides = {}) => {
  if (!biz) return {};
  const defaults = getDefaultFeatures(biz.tipo_negocio, biz.plan);
  return {
    ...defaults,
    feature_staff: biz.feature_staff !== undefined ? biz.feature_staff : defaults.feature_staff,
    feature_services: biz.feature_services !== undefined ? biz.feature_services : defaults.feature_services,
    feature_appointments: biz.feature_appointments !== undefined ? biz.feature_appointments : defaults.feature_appointments,
    feature_orders: biz.feature_orders !== undefined ? biz.feature_orders : defaults.feature_orders,
    feature_inventory: biz.feature_inventory !== undefined ? biz.feature_inventory : defaults.feature_inventory,
    feature_commissions: biz.feature_commissions !== undefined ? biz.feature_commissions : defaults.feature_commissions,
    feature_campaigns: biz.feature_campaigns !== undefined ? biz.feature_campaigns : defaults.feature_campaigns,
    feature_loyalty: biz.feature_loyalty !== undefined ? biz.feature_loyalty : defaults.feature_loyalty,
    feature_prospecting: biz.feature_prospecting !== undefined ? biz.feature_prospecting : defaults.feature_prospecting,
    feature_catalogo: biz.feature_catalogo !== undefined ? biz.feature_catalogo : defaults.feature_catalogo,
    feature_cotizaciones: biz.feature_cotizaciones !== undefined ? biz.feature_cotizaciones : defaults.feature_cotizaciones,
    feature_menu_media: biz.feature_menu_media !== undefined ? biz.feature_menu_media : defaults.feature_menu_media,
    feature_identidad_ia: biz.feature_identidad_ia !== undefined ? biz.feature_identidad_ia : defaults.feature_identidad_ia,
    feature_finanzas: biz.feature_finanzas !== undefined ? biz.feature_finanzas : defaults.feature_finanzas,
    feature_bot_aprende: biz.feature_bot_aprende !== undefined ? biz.feature_bot_aprende : defaults.feature_bot_aprende,
    feature_reportes: biz.feature_reportes !== undefined ? biz.feature_reportes : defaults.feature_reportes,
    feature_seguimiento: biz.feature_seguimiento !== undefined ? biz.feature_seguimiento : defaults.feature_seguimiento,
    feature_contenido: biz.feature_contenido !== undefined ? biz.feature_contenido : defaults.feature_contenido,
    feature_ads: biz.feature_ads !== undefined ? biz.feature_ads : defaults.feature_ads,
    bot_activo: biz.bot_activo !== undefined ? biz.bot_activo : true,
    whatsapp_enabled: biz.whatsapp_enabled !== undefined ? biz.whatsapp_enabled : true,
    menu_pdf_url: biz.menu_pdf_url || "",
    menu_link_url: biz.menu_link_url || "",
    menu_text_list: biz.menu_text_list || "",
    muted_phones: Array.isArray(biz.muted_phones) ? biz.muted_phones : [],
    muted_phones_metadata: biz.muted_phones_metadata || {},
    custom_instructions: biz.custom_instructions || "",
    ...overrides
  };
};

export const buildEstiloWithFeatures = (cleanEstiloText, featuresObj) => {
  const clean = (cleanEstiloText || '').split('__FEATURES__:')[0].split('[REGLAS ADICIONALES DEL NEGOCIO]')[0].trim();
  let result = clean;
  if (featuresObj.custom_instructions && featuresObj.custom_instructions.trim() !== '') {
    result += `\n\n[REGLAS ADICIONALES DEL NEGOCIO]\n${featuresObj.custom_instructions.trim()}\n\n`;
  }
  return `${result}__FEATURES__:${JSON.stringify(featuresObj)}`;
};
